import React from 'react'
import Shearchbar from './Shearchbar'
import Manubar from './Manubar'
import Navbar from './Navbar'
import Security from './Security'
import Footer from './Footer'

const Moblle_category = () => {
    return (
        <div >
            <div className="modal fade offcanvas-modal" id="exampleModal">
                <div className="modal-dialog offcanvas-dialog">
                    <div className="modal-content">
                        <Manubar />
                    </div>
                </div>
            </div>
            <Shearchbar />
            <Navbar />


       <div>
        <ul style={{display:"flex",flexWrap:"wrap",}} className='justify-content-around'>
            <li><img src="https://www.w3schools.com/w3images/tablesetting.jpg" alt="" style={{marginTop:"8px"}} height={"80px"} width={"80px"} /></li>
            <li><img src="https://www.w3schools.com/w3images/tablesetting.jpg" alt="" style={{marginTop:"8px"}} height={"80px"} width={"80px"} /></li>
            <li><img src="https://www.w3schools.com/w3images/tablesetting.jpg" alt="" style={{marginTop:"8px"}} height={"80px"} width={"80px"} /></li>
            <li><img src="https://www.w3schools.com/w3images/tablesetting.jpg" alt="" style={{marginTop:"8px"}} height={"80px"} width={"80px"} /></li>
            <li><img src="https://www.w3schools.com/w3images/tablesetting.jpg" alt="" style={{marginTop:"8px"}} height={"80px"} width={"80px"} /></li>
            <li><img src="https://www.w3schools.com/w3images/tablesetting.jpg" alt="" style={{marginTop:"8px"}} height={"80px"} width={"80px"} /></li>
            <li><img src="https://www.w3schools.com/w3images/tablesetting.jpg" alt="" style={{marginTop:"8px"}} height={"80px"} width={"80px"} /></li>
            <li><img src="https://www.w3schools.com/w3images/tablesetting.jpg" alt="" style={{marginTop:"8px"}} height={"80px"} width={"80px"} /></li>
        </ul>
       </div>
       <Security />
      <Footer />

        </div>
    )
}

export default Moblle_category